export const Topics = () => {
    return (
        <>
            <div className='mt-40 md:mt-0'>
                <div className='relative'>
                    <div className='flex'>
                        <img
                            className='w-auto mx-auto'
                            src={`${process.env.PUBLIC_URL}/images/title-wood.png`}
                            alt=' What is Phantom Brave: The Lost Hero?'
                        />
                        <h1 className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-gradient-title text-lg w-full md:text-xlg font-pop'>
                            Topics
                        </h1>{' '}
                    </div>
                </div>{' '}
                <div className='frame-fluid mt-8'>
                    <div className=' flex flex-col justify-center px-4 my-8 mx-auto max-w-[500px]'>
                        <button>
                            <a target='_blank' rel='noreferrer' href='https://tgs.sega.jp/en/lineup/pb_losthero.html'>
                                <img
                                    className='w-auto shadow-xl'
                                    src={`${process.env.PUBLIC_URL}/images/topics/tgs_800x460.webp`}
                                    alt='Phantom brave: The lost hero at TGS 2024'
                                />{' '}
                            </a>
                        </button>
                    </div>
                </div>{' '}
            </div>
        </>
    )
}
